export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/zonademand_UB_mobile.2ac52882.png";